import createLucideIcon from '../createLucideIcon';

const ArrowBigRightDash = createLucideIcon('ArrowBigRightDash', [
  ['path', { d: 'M5 9v6', key: '158jrl' }],
  ['path', { d: 'M9 9h3V5l7 7-7 7v-4H9V9z', key: '1sg2xn' }],
]);

export default ArrowBigRightDash;
